import axios, { AxiosError } from "axios";

export const readErrorMessage = (error: unknown): string | undefined =>
  axios.isAxiosError(error) ? (error as AxiosError<{ message?: string }>).response?.data?.message : undefined;

export const buildAuthHeaders = (accessTokenKey: string) => ({
  Authorization: `${localStorage.getItem(accessTokenKey)}`,
  "Content-Type": "application/json",
});

export const tileUrl = (baseUrl: string, id: string): string => `${baseUrl}${encodeURIComponent(id)}/`;
